module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-portal-1.d1a925b1.svg";